import { asDateString } from './member-update-payload.util';

export interface EnquiryPayloadOptions {
  includeCompanyBranch?: boolean;
  modifiedBy?: string;
}

/** Body for PATCH .../branches/:branchId/enquiries/:id (UpdateEnquiryDto). */
export function buildEnquiryUpdatePayload(
  enquiry: object,
  options: EnquiryPayloadOptions = {},
): Record<string, unknown> {
  const e = (enquiry || {}) as Record<string, unknown>;
  const payload: Record<string, unknown> = {};

  if (e.name) payload.name = e.name;
  if (e.email !== undefined && e.email !== null) payload.email = e.email;
  if (e.gender) payload.gender = e.gender;

  const contact = e.contact ?? e.phone;
  if (contact) payload.contact = contact;

  const enquiryDate = asDateString(e.enquirydate);
  if (enquiryDate) payload.enquirydate = enquiryDate;

  const expectedJoining = asDateString(e.expectedJoining);
  if (expectedJoining) payload.expectedJoining = expectedJoining;

  if (e.interestLevel) payload.interestLevel = e.interestLevel;
  if (e.comments !== undefined && e.comments !== null) payload.comments = e.comments;
  if (e.question1) payload.question1 = e.question1;
  if (e.question2) payload.question2 = e.question2;
  if (e.profession) payload.profession = e.profession;
  if (e.address) payload.address = e.address;
  if (e.medicaldetails !== undefined && e.medicaldetails !== null) {
    payload.medicaldetails = e.medicaldetails;
  }

  if (options.includeCompanyBranch) {
    if (e.company) payload.company = e.company;
    if (e.branch) payload.branch = e.branch;
  }

  if (options.modifiedBy) {
    payload.modifiedBy = options.modifiedBy;
  } else if (e.modifiedBy) {
    payload.modifiedBy = e.modifiedBy;
  }

  return payload;
}

/** Body for POST .../branches/:branchId/enquiries/:id/actions/approve (ApproveEnquiryDto). */
export function buildApproveEnquiryPayload(memberId: string): Record<string, unknown> {
  return { data: { id: memberId } };
}

/**
 * Body for POST .../branches/:branchId/enquiries (CreateEnquiryDto).
 * Company/branch are resolved server-side from the URL + auth, so they are
 * not sent in the body.
 */
export function buildEnquiryCreatePayload(
  enquiry: object,
  createdBy?: string,
): Record<string, unknown> {
  const payload = buildEnquiryUpdatePayload(enquiry, { includeCompanyBranch: false });
  delete payload.modifiedBy;
  if (createdBy) payload.createdBy = createdBy;
  return payload;
}
